import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Button,
  Slide,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import simplemanLogo from "../image/simpleman-white.png";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
};

// Esempio di stile personalizzato per la parte superiore della dialog
const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(2, 3),
}));

// Esempio di container per il logo e il titolo
const TitleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
});

// Esempio di stile per il logo
const Logo = styled("img")({
  height: 40,
});

export default function WelcomeDialog({
  open = true,
  onClose,
  secondsRemaining,
  loading = true
}) {
    return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={(event, reason) => {
        if (reason && reason === "backdropClick") {
          return;
        }

        onClose()
      }}
      aria-labelledby="welcome-dialog-title"
      aria-describedby="welcome-dialog-description"
      disableEscapeKeyDown
    >
      <StyledDialogTitle id="welcome-dialog-title">
        <TitleContainer>
          <Typography variant="h6" component="div">
            <Logo src={simplemanLogo} alt="Logo Simpleman" />
            <Typography>Area demo</Typography>
          </Typography>
        </TitleContainer>
      </StyledDialogTitle>

      <DialogContent>
        <DialogContentText id="welcome-dialog-description" component="div">
          <Typography variant="body1" sx={{ mt: 2 }}>
            Hai a disposizione <strong>{formatTime(secondsRemaining)}</strong> minuti per l’utilizzo degli smartphone.
          </Typography>

          <Typography variant="body1" sx={{ mt: 2 }}>
            Puoi seguire gli step del tutorial passo passo, manovrando gli smartphone come se fossero reali.
            Al termine di ogni step, clicca su "Ho finito" per passare a quello successivo.
          </Typography>

          <Typography variant="body1" sx={{ mt: 2 }}>
            <em>
              Al termine dei minuti rimanenti potrai comunque continuare a esplorare la demo,
              ma <strong>gli smartphone non saranno più utilizzabili</strong>.
            </em>
          </Typography>

          <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>
              Attendi la fine del caricamento per iniziare.
            </strong>
          </Typography>

          <Typography variant="body1" sx={{ mt: 2 }}>
            Per qualsiasi dubbio puoi contattare il commerciale tramite email (pulsante Contatta il commerciale)
            o numero di telefono: 388 824 7836.
          </Typography>
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            window.location = "mailto:pasquale.dipede@simpleman.it";
          }}
        >
          Contatta il commerciale
        </Button>

        <Button
          variant="contained"
          loading={loading}
          disabled={loading}
          onClick={() => {
            if (onClose) onClose();
          }}
        >
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  );
}
